import {
  AddCollaboratorsHistoryEducationResponse,
  AddUpdateCollaboratorsEducation,
  GetCollaboratorsHistoryEducationsResponse,
} from "../../../types/api/collaborators.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CollaboratorsHistoryEducationsService = {
  async list(
    collaboratorId: number,
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCollaboratorsHistoryEducationsResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";
    const response =
      await httpClient.get<GetCollaboratorsHistoryEducationsResponse>(
        `v1/collaborators/${collaboratorId}/history/education?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
        { signal },
      );
    return response;
  },
  async add(
    collaboratorId: number,
    body: AddUpdateCollaboratorsEducation,
  ): Promise<AddCollaboratorsHistoryEducationResponse> {
    const response = await httpClient.post<
      AddUpdateCollaboratorsEducation,
      AddCollaboratorsHistoryEducationResponse
    >(`v1/collaborators/${collaboratorId}/history/education`, body);
    return response;
  },
  async update(
    collaboratorId: number,
    educationId: number,
    body: AddUpdateCollaboratorsEducation,
  ): Promise<void> {
    await httpClient.put(
      `v1/collaborators/${collaboratorId}/history/education/${educationId}`,
      body,
    );
  },
  async delete(collaboratorId: number, educationId: number): Promise<void> {
    await httpClient.delete(
      `v1/collaborators/${collaboratorId}/history/education/${educationId}`,
    );
  },
};

export default CollaboratorsHistoryEducationsService;
